export default "__VITE_ASSET__BCw8RlQx__"